import { Component, Inject, OnInit } from '@angular/core';
import { ApiRequestService } from '../../shared/api-request-service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModifyPersonalDataRequest } from './modifypersonaldatarequest';
import { ModifyPersonalDataResponse } from './modifypersonaldataresponse';
import { Router } from '@angular/router';
import { PersonalData } from './personaldata';
import { DeleteAccountRequest } from './deleteaccountrequest';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { DeleteAccountPopupComponent } from './deleteaccountpopup/deleteaccountpopup.component';

@Component({
    selector: 'pw-loggedinuserpersonaldata',
    templateUrl: './personaldata.component.html',
    styleUrls: ['./personaldata.component.scss']
})
export class PersonalDataComponent implements OnInit {
    orderBackendUrl = '';

    authBackendUrl = '';

    contactForm: FormGroup = new FormGroup({});

    contactFormCompany: FormGroup = new FormGroup({});

    personalData: PersonalData = {};

    modifyPersonalDataUrl = '/modifypersonaldata';

    modifyPersonalDataRequest: ModifyPersonalDataRequest = {};

    modifyPersonalDataResponse: ModifyPersonalDataResponse = {};

    isSubscribedForNewsLetter = false;

    deleteAccountUrl = '/delete-account';

    deleteAccountRequest: DeleteAccountRequest = {};

    isExtraSmall: Observable<BreakpointState>;
    isSmall: Observable<BreakpointState>;
    isMedium: Observable<BreakpointState>;
    hungarianPhonePrefix = '+36';

    phoneNumberPattern = '^(?:[0-9] ?){6,14}[0-9]$|^(\\+\\d{1,3}( )?)?((\\(\\d{3}\\))|\\d{3})[- .]?\\d{3}[- .]?\\d{4}$|^(\\+\\d{1,3}( )?)?(\\d{3}[ ]?){2}\\d{3}$|^(\\+\\d{1,3}( )?)?(\\d{3}[ ]?)(\\d{2}[ ]?){2}\\d{2}$';

    constructor(
        private _fb: FormBuilder,
        private _fbCompany: FormBuilder,
        @Inject('AUTH_BACKEND_URL') private _authBackendUrl: string,
        private _apiRequestService: ApiRequestService,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string,
        private _router: Router,
        private _toastMessageService: ToastmessageService,
        private readonly breakpointObserver: BreakpointObserver,
        private _matDialog: MatDialog,
    ) {
        this.orderBackendUrl = _orderBackendUrl;
        this.authBackendUrl = _authBackendUrl;
        this.createForm();
        this.isExtraSmall = this.breakpointObserver.observe(Breakpoints.XSmall);
        this.isSmall = this.breakpointObserver.observe(Breakpoints.Small);
        this.isMedium = this.breakpointObserver.observe(Breakpoints.Medium);
    }


    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    ngOnInit(): void {
        if (sessionStorage.getItem('personalData')) {
            this.personalData = JSON.parse(sessionStorage.getItem('personalData') as string) as PersonalData;
            this.isSubscribedForNewsLetter = this.personalData.subscribedForNewsLetter as boolean;
        } else {
            this._router.navigateByUrl('/');
        }
    }

    createForm() {
        this.createIndividualAndCompanyForms();
    }

    createIndividualAndCompanyForms() {
        this.contactForm = this._fb.group({
            firstName: ['', [Validators.required, Validators.minLength(3)]],
            lastName: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            zipCode: ['', [Validators.required, Validators.pattern('[0-9]{4}')]],
            settlement: ['', [Validators.required, Validators.minLength(3)]],
            address: ['', Validators.required],
            phoneNumber: ['', [Validators.required,Validators.pattern(this.phoneNumberPattern)]]
        });

        this.contactForm.get('email')?.disable();

        this.contactFormCompany = this._fbCompany.group({
            companyName: ['', [Validators.required, Validators.minLength(3)]],
            firstName: ['', [Validators.required, Validators.minLength(3)]],
            lastName: ['', [Validators.required, Validators.minLength(3)]],
            companyEmail: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            vatNumber: ['', Validators.required],
            companyZipCode: ['', [Validators.required, Validators.pattern('[0-9]{4}')]],
            companySettlement: ['', [Validators.required, Validators.minLength(3)]],
            companyAddress: ['', Validators.required],
            phoneNumber: ['', [Validators.required,Validators.pattern(this.phoneNumberPattern)]]
        });

        this.contactFormCompany.get('companyEmail')?.disable();
    }

    collectIndividualData() {
        this.personalData = {
            isCompany: this.personalData?.isCompany,
            email: this.contactForm?.controls['email'].value as string | undefined,
            firstName: this.contactForm?.controls['firstName'].value as string | undefined,
            lastName: this.contactForm?.controls['lastName'].value as string | undefined,
            zipCode: this.contactForm?.controls['zipCode'].value as number | undefined,
            settlement: this.contactForm?.controls['settlement'].value as string | undefined,
            address: this.contactForm?.controls['address'].value as string | undefined,
            phoneNumber: this.contactForm?.controls['phoneNumber'].value as string | undefined
        };
    }
    collectCompanyData() {
        this.personalData = {
            isCompany: this.personalData?.isCompany,
            email: this.contactFormCompany?.controls['companyEmail'].value as string | undefined,
            companyName: this.contactFormCompany?.controls['companyName'].value as string | undefined,
            firstName: this.contactFormCompany?.controls['firstName'].value as string | undefined,
            lastName: this.contactFormCompany?.controls['lastName'].value as string | undefined,
            taxNumber: this.contactFormCompany?.controls['vatNumber'].value as string | undefined,
            zipCode: this.contactFormCompany?.controls['companyZipCode'].value as number | undefined,
            settlement: this.contactFormCompany?.controls['companySettlement'].value as string | undefined,
            address: this.contactFormCompany?.controls['companyAddress'].value as string | undefined,
            phoneNumber: this.contactFormCompany?.controls['phoneNumber'].value as string | undefined
        };
    }

    updateCompanyData() {
        if (this.isPhoneNumberValid(this.personalData?.phoneNumber!)) {
        this.collectCompanyData();
        if (this.isSubscribedForNewsLetter) {
            if (this.personalData) {
                this.personalData.subscribedForNewsLetter = true;
            }
        } else {
            if (this.personalData) {
                this.personalData.subscribedForNewsLetter = false;
            }
        }

        this.modifyPersonalDataRequest = {
            personalData: this.personalData
        };

        this._apiRequestService
            .sendRequest(this.authBackendUrl, true, this.modifyPersonalDataRequest, true, this.modifyPersonalDataUrl)
            .subscribe((answer) => {
                this.modifyPersonalDataResponse = answer as ModifyPersonalDataResponse;
                //refresh personalData in session if update is successfull
                if (this.modifyPersonalDataResponse.message === 'Sikeres adatmódosítás!') {
                    sessionStorage.setItem('personalData', JSON.stringify(this.personalData));
                }
                alert(this.modifyPersonalDataResponse.message);
            });
        }
    }

    updateIndividualData() {
        if (this.isPhoneNumberValid(this.personalData?.phoneNumber!)) {
        this.collectIndividualData();

        if (this.isSubscribedForNewsLetter) {
            if (this.personalData) {
                this.personalData.subscribedForNewsLetter = true;
            }
        } else {
            if (this.personalData) {
                this.personalData.subscribedForNewsLetter = false;
            }
        }
        this.modifyPersonalDataRequest = {
            personalData: this.personalData
        };

        this._apiRequestService
            .sendRequest(this.authBackendUrl, true, this.modifyPersonalDataRequest, true, this.modifyPersonalDataUrl)
            .subscribe((answer) => {
                this.modifyPersonalDataResponse = answer as ModifyPersonalDataResponse;
                //refresh personalData in session if update is successfull
                if (this.modifyPersonalDataResponse.message === 'Sikeres adatmódosítás!') {
                    sessionStorage.setItem('personalData', JSON.stringify(this.personalData));
                }
                this._toastMessageService.displayToastMessage(TOAST_STATE.success, this.modifyPersonalDataResponse.message!, MAT_ICON.success);
                this.dismissError();
            });
        }
    }

    unsubscribeForNewsLetter() {
        this.isSubscribedForNewsLetter = !this.isSubscribedForNewsLetter;
    }

    subscribeForNewsLetter() {
        this.isSubscribedForNewsLetter = !this.isSubscribedForNewsLetter;
    }

    deleteAccount(email: string) {
        const popupDialog = this._matDialog.open(DeleteAccountPopupComponent, {
            data: email,
            width: 'calc(100% - 50px)',
            maxWidth: '100vw',
            height: '80%'
        });
        const xsmallDialogSubscription = this.isExtraSmall.subscribe((size) => {
            if (size.matches) {
                popupDialog.updateSize('100vw', '100%');
            } else {
                popupDialog.updateSize('calc(60% - 50px)', '');
            }
        });

        popupDialog.afterClosed().subscribe(() => {
            xsmallDialogSubscription.unsubscribe();
        });

    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    isPhoneNumberValid(phoneNumber: string): boolean {
        if (phoneNumber.substring(0, 2) === '06' || phoneNumber.substring(0, 3) === '+36' || phoneNumber.substring(0, 4) === '0036') {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'A telefonszám első karakterei nem tartalmazhatják a "06", "+36" és "0036" előhívószámokat!', MAT_ICON.warning);
            this.dismissError();
            return false;

        }
        return true
    }
}
